import { v4 as uuidv4 } from "uuid";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { applyCurrencyRounding, getRoundingMethod } from "../../../../utils/tillHelpers";

export const BuyXGetYDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let excludingFlag = true;
  const tillData = useAuthStore.getState().tillData;
  // BUG-1864: resolve each line's own qty precision (0 for unit-based products) instead of
  // leaving weight subtraction/merge unrounded — floating point residue (e.g. 1.0100000000000002)
  // otherwise survives display as a decimal quantity on a whole-unit product.
  const getQtyRoundPrecision = (item) => {
    const qtyPrecision = parseInt(item?.uomData?.[0]?.stdprecision ?? item?.isQtyDesimal, 10);
    return !isNaN(qtyPrecision) ? qtyPrecision : tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  };
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === product.mProductCategoryId);

  if (
    (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
    (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy && pricingRule.mPricingPcategories.length > 0) ||
    (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
  ) {
    excludingFlag = false;
  }

  const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === product.productBrandId);

  if (
    (pricingRule.excludeBrands === "Y" && matchingBrand) ||
    (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
    (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
  ) {
    excludingFlag = false;
  }

  const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === product.productId);

  if (
    (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
    (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
    (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
  ) {
    excludingFlag = false;
  }

  if (saleTypeValidation && excludingFlag) {
    let addedToCart = [...cartObj.items]; // Create a copy of cartObj.items
    const offerProducts = pricingRule.mPricingXProducts;
    const freeProducts = pricingRule.mPricingXProducts.filter((prod) => prod.isFree === "Y");
    const conditionalProducts = pricingRule.mPricingXProducts.filter((prod) => prod.isFree === "N");
    const promotionCandidates = [];

    addedToCart.map((item) => {
      freeProducts.map((ele) => {
        if (ele.mProductId === item.productId) {
          item.discountName = "";
          item.mPricingruleId = null;
          item.discount = 0;
          item.discountType = "";
          item.freeItem = "N";
        }
      });
    });

    let uniqueItemsMap = {};
    const seenId = new Set();

    addedToCart.forEach((item, index) => {
      const key = item.productId;

      if (!seenId.has(item.lineId)) {
        seenId.add(item.lineId);
        if (!uniqueItemsMap[key]) {
          uniqueItemsMap[key] = { ...item };
        } else {
          uniqueItemsMap[key].weight += item.weight;
          uniqueItemsMap[key].nettotal += item.nettotal;
          uniqueItemsMap[key].taxAmount += item.taxAmount;
          uniqueItemsMap[key].discount += item.discount;
        }
      }
    });

    // BUG-1864: normalize each merged line's weight to its own qty precision. Summing several
    // fragment weights with `+=` can leave float residue (e.g. 2.9999999999999996) that would
    // otherwise flow straight into the split/eligibility math below.
    const uniqueItems = Object.values(uniqueItemsMap).map((item) => {
      item.weight = parseFloat(item.weight.toFixed(getQtyRoundPrecision(item)));
      return item;
    });

    // Convert back to array
    addedToCart = uniqueItems;

    let matchedItems = [];
    addedToCart.forEach((ele) => {
      if (ele.discount <= 0) {
        const matchingProduct = pricingRule.mPricingXProducts.find((res) => res.mProductId === ele.productId);
        if (matchingProduct) {
          delete ele.priority;
        }
      }
      conditionalProducts.forEach((condProduct) => {
        if (
          ele.productId === condProduct.mProductId &&
          (!ele?.discountType || ele?.discountType === "") &&
          ele.weight >= condProduct.quantity &&
          (ele?.priority ? ele?.priority < pricingRule.priority : true)
        ) {
          let remainingQuantity = ele.weight;
          // Create a new item with remaining quantity
          if (condProduct.quantity && condProduct.quantity > 0) {
            for (let index = remainingQuantity; index >= condProduct.quantity; index -= condProduct.quantity) {
              let newItem = { ...ele }; // Create a copy of the item
              newItem.weight = condProduct.quantity; // Set the quantity to the conditional product quantity
              remainingQuantity -= condProduct.quantity;
              matchedItems.push(newItem); // Push the new item to matchedItems
            }
          }
        }
      });
    });

    let hasChanges = false;
    if (matchedItems.length > 0) {
      let uniqueMatchedItems = [];
      matchedItems.forEach((item) => {
        if (!uniqueMatchedItems.some((pushItem) => pushItem.productId === item.productId && pushItem.lineId === item.lineId && !pushItem.mPricingruleId)) {
          item = { ...item }; // Create a copy of the item to avoid modifying original data
          const mrp = parseFloat(item.realPrice) * item.quantity;
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
          item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          // item.discount = 0;
          item.weight = item.quantity;
          // item.discountName = pricingRule.printedName;
          item.mPricingruleId = pricingRule.mPricingrulesId;
          // item.discountType = "XGY";
          uniqueMatchedItems.push(item);
        }
      });

      let matchedFreeItems = [];

      addedToCart.forEach((ele) => {
        if (ele.discount <= 0) {
          delete ele.priority;
        }
        freeProducts.forEach((freeItem) => {
          if (
            ele.productId === freeItem.mProductId &&
            (!ele?.discountType || ele?.discountType === "") &&
            !ele.mPricingruleId &&
            (iscoupon ? (ele?.priority ? ele?.priority < pricingRule.priority || ele.mPricingruleId === pricingRule.mPricingrulesId : true) : true)
          ) {
            let remainingQuantity = ele.weight;
            // Create a new item with remaining quantity
            for (let index = remainingQuantity; index >= freeItem.quantity; index -= freeItem.quantity) {
              let newItem = { ...ele }; // Create a copy of the item to avoid modifying original data
              remainingQuantity -= freeItem.quantity;
              newItem.discountType = "XGY";
              newItem.freeItem = "Y";
              const realPrice = parseFloat(newItem.realPrice) || 0;
              // discountType/percentageDiscount/amountDiscount are optional on XGY rules; when unset
              // (legacy "Buy X Get Y Free" rules configured before partial-discount support existed),
              // preserve the original fully-free behavior instead of silently charging full price.
              let discountPerUnit = realPrice;
              if (pricingRule.discountType === "V" && pricingRule.amountDiscount !== null && pricingRule.amountDiscount !== undefined) {
                discountPerUnit = parseFloat(pricingRule.amountDiscount) || 0;
              } else if (pricingRule.discountType === "P" && pricingRule.percentageDiscount !== null && pricingRule.percentageDiscount !== undefined) {
                discountPerUnit = ((parseFloat(pricingRule.percentageDiscount) || 0) / 100) * realPrice;
              }
              // TSK-3145: cap at realPrice so a misconfigured flat amountDiscount or a
              // percentageDiscount > 100 can't push sp/nettotal negative.
              discountPerUnit = realPrice >= 0 && discountPerUnit > realPrice ? realPrice : discountPerUnit;
              const sp = realPrice - discountPerUnit;
              newItem.weight = freeItem.quantity ? freeItem.quantity : 1;
              const mrp = sp * newItem.weight;
              const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + newItem.taxRate / 100) : (mrp * newItem.taxRate) / 100;
              newItem.salePrice = sp;
              newItem.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
              newItem.nettotal =
                taxIncludeFlag === "Y"
                  ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                  : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
              newItem.priority = pricingRule.priority;
              newItem.discount = parseFloat((discountPerUnit * newItem.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
              newItem.discountName = pricingRule.printedName;
              newItem.mPricingruleId = pricingRule.mPricingrulesId;
              matchedFreeItems.push(newItem); // Push the new item to matchedItems
            }
          }
        });
      });

      matchedItems.forEach((ele, ind) => {
        if (matchedFreeItems.length > 0 && matchedFreeItems[ind]) {
          // matchedItems[ind].priority = pricingRule.priority;
          matchedItems[ind].mPricingruleId = pricingRule.mPricingrulesId;
          hasChanges = true;
          let obj = {
            isFreeProductFlag: true,
            items: [matchedFreeItems[ind], matchedItems[ind]],
          };
          promotionCandidates.push(obj);
        } else if (matchedFreeItems.length >= ind + 1 && matchedFreeItems[ind]) {
          const sp = matchedFreeItems[ind].realPrice;
          const mrp = sp * matchedFreeItems[ind].weight;
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + matchedFreeItems[ind].taxRate / 100) : (mrp * matchedFreeItems[ind].taxRate) / 100;
          matchedFreeItems[ind].salePrice = sp;
          matchedFreeItems[ind].taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          matchedFreeItems[ind].nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          matchedFreeItems[ind].discount = 0;
          matchedFreeItems[ind].discountName = "";
          matchedFreeItems[ind].mPricingruleId = null;
        } else if (matchedItems.length >= ind + 1 && matchedItems[ind]) {
          const fsp = matchedItems[ind].realPrice;
          const fmrp = fsp * matchedItems[ind].weight;
          const ftax = taxIncludeFlag === "Y" ? fmrp - fmrp / (1 + matchedItems[ind].taxRate / 100) : (fmrp * matchedItems[ind].taxRate) / 100;
          matchedItems[ind].salePrice = fsp;
          matchedItems[ind].taxAmount = parseFloat(ftax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          matchedItems[ind].nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(fmrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((fmrp + ftax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          // matchedItems[ind].discount = 0;
          // matchedItems[ind].discountName = "";
          // matchedItems[ind].mPricingruleId = null;
        }
      });
    }

    // "All Y" configuration: every configured product on the rule is flagged isFree="Y" with no
    // isFree="N" trigger product (e.g. all 3 rows Free in the backoffice). Mirrors the xQty/yQty
    // quantity-threshold pattern used by BuyXPayYOfDifferent.js (BXD): any xQty qualifying units
    // from the list trigger a discount on yQty of the cheapest matching units, applied per
    // discountType instead of BXD's always-free. Falls back to requiring one unit of every
    // configured product when xQty/yQty aren't set, since that's the only trigger count implied
    // by the rule's own product list in that case.
    //
    // Mutates each matched line's discount/nettotal fields in place (BXD's approach for a
    // partial-quantity discount on a single line) instead of splitting it into separate lines —
    // the cart must show one line per product, e.g. qty 2 with a blended discount, not a
    // discounted-qty line plus a separate full-price-qty line for the same product.
    if (conditionalProducts.length === 0 && freeProducts.length > 0) {
      const requiredXQty = pricingRule.xQty > 0 ? pricingRule.xQty : freeProducts.length;
      const discountUnitCount = pricingRule.yQty > 0 ? pricingRule.yQty : 1;

      const eligibleLines = [];
      freeProducts.forEach((freeItem) => {
        const ele = addedToCart.find(
          (item) =>
            item.productId === freeItem.mProductId &&
            (!item?.discountType || item?.discountType === "") &&
            !item.mPricingruleId &&
            (iscoupon ? (item?.priority ? item?.priority < pricingRule.priority || item.mPricingruleId === pricingRule.mPricingrulesId : true) : true)
        );
        if (ele) eligibleLines.push(ele);
      });

      const totalQty = eligibleLines.reduce((sum, ele) => sum + ele.weight, 0);

      if (totalQty >= requiredXQty) {
        const groupCount = Math.floor(totalQty / requiredXQty);
        let unitsToDiscount = Math.min(groupCount * discountUnitCount, totalQty);

        const sortedLines = [...eligibleLines].sort((a, b) => parseFloat(a.realPrice) - parseFloat(b.realPrice));

        sortedLines.forEach((ele) => {
          if (unitsToDiscount <= 0) return; // leave lines beyond the discount budget completely untouched

          const discountQty = Math.min(ele.weight, unitsToDiscount);
          const realPrice = parseFloat(ele.realPrice) || 0;

          let discountPerUnit = 0;
          if (pricingRule.discountType === "V" && pricingRule.amountDiscount !== null && pricingRule.amountDiscount !== undefined) {
            discountPerUnit = parseFloat(pricingRule.amountDiscount) || 0;
          } else if (pricingRule.discountType === "P" && pricingRule.percentageDiscount !== null && pricingRule.percentageDiscount !== undefined) {
            discountPerUnit = ((parseFloat(pricingRule.percentageDiscount) || 0) / 100) * realPrice;
          } else {
            discountPerUnit = realPrice;
          }
          // TSK-3145: cap at realPrice so a misconfigured flat amountDiscount or a
          // percentageDiscount > 100 can't push netTotal negative.
          discountPerUnit = realPrice >= 0 && discountPerUnit > realPrice ? realPrice : discountPerUnit;

          const discountAmt = discountPerUnit * discountQty;
          const grossMrp = realPrice * ele.weight;
          const netTotal = grossMrp - discountAmt;
          const tax = taxIncludeFlag === "Y" ? netTotal - netTotal / (1 + ele.taxRate / 100) : (netTotal * ele.taxRate) / 100;

          ele.discountType = "XGY";
          ele.freeItem = "Y";
          ele.discountName = pricingRule.printedName;
          ele.mPricingruleId = pricingRule.mPricingrulesId;
          ele.priority = pricingRule.priority;
          ele.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          ele.discount = parseFloat(discountAmt.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          ele.nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(netTotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((netTotal + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));

          hasChanges = true;
          unitsToDiscount -= discountQty;
        });
      }
    }

    promotionCandidates.forEach((promotionItems) => {
      if (promotionItems.isFreeProductFlag) {
        addedToCart = addedToCart.filter((item) => item !== null && item !== undefined);
        promotionItems.items = promotionItems.items.filter((item) => item !== null && item !== undefined);
        promotionItems.items.map((ele) => {
          const index = addedToCart.findIndex((item, ind) => {
            if (item) {
              if (item.productId === ele.productId && ele.lineId === item.lineId) {
                return ind >= 0 ? true : false;
              }
            }
          });

          if (index >= 0) {
            const mrp = parseFloat(addedToCart[index].realPrice) * (addedToCart[index].weight - ele.weight);
            const tax = mrp - mrp / (1 + addedToCart[index].taxRate / 100);
            addedToCart[index].taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            addedToCart[index].nettotal = parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            // addedToCart[index].discount = 0;
            // BUG-1864: round the remainder to the line's own qty precision — otherwise a unit-based
            // product can be left at e.g. 1.0100000000000002 after the promo fragment's weight is
            // subtracted out, which then also slips past the exact `=== 0` remainder check below.
            addedToCart[index].weight = parseFloat((addedToCart[index].weight - ele.weight).toFixed(getQtyRoundPrecision(addedToCart[index])));
            // addedToCart[index].discountName = "";
            addedToCart[index].mPricingruleId = null;
            if (addedToCart[index].weight <= 0) {
              delete addedToCart[index];
            }
          }
        });
        addedToCart = [...addedToCart, ...promotionItems.items];
      }
    });
    let flag = true;
    addedToCart = addedToCart.filter((item) => {
      if (item !== null && item !== undefined) {
        if (product.productId === item.productId && flag) {
          // Fall back to the item's own existing lineId when the caller doesn't supply one
          // (product.lineId undefined) instead of blanking out the line's identity. Preserves
          // the original-line-identity guarantee that af7dc3ee (BUG-1691) relied on for the
          // no-split "all isFree=Y" mutate-in-place path.
          item.lineId = product.lineId || item.lineId;
          flag = false;
        } else {
          item.lineId = uuidv4().replace(/-/g, "").toUpperCase();
        }
        const sp = item.realPrice;
        const mrp = sp * item.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
        item.salePrice = sp;
        item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.nettotal =
          taxIncludeFlag === "Y"
            ? parseFloat((mrp - item.discount).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
            : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        return item;
      }
    });

    if (hasChanges) {
      let totalTax = 0;
      let totalPrice = 0;
      let totalItemsQty = 0;
      let totalDiscounts = 0;
      for (let i = 0; i < addedToCart.length; i += 1) {
        totalPrice += addedToCart[i].nettotal;
        totalItemsQty += addedToCart[i].weight;
        totalTax += addedToCart[i].taxAmount;
        totalDiscounts += addedToCart[i].discount;
        addedToCart[i].key = i;
      }

      let couponsData = cart.couponInput?.length > 0 ? [...cart.couponInput] : [];
      if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null && mPricingRulesId) {
        couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
      }

      const { roundedTotal: roundOffValue, roundOffAmount: totalRoundOff } = applyCurrencyRounding(totalPrice, getRoundingMethod(tillData));
      totalPrice = roundOffValue;
      let finalCartObj = {
        ...cartObj,
        couponInput: couponsData,
        items: [...addedToCart],
        total: totalPrice,
        tax: totalTax,
        discount: totalDiscounts,
        totalQty: totalItemsQty,
        roundOff: totalRoundOff,
      };
      if (isExchange) {
        useCartStore.getState().setExchangeCart(finalCartObj);
      } else {
        setCart(finalCartObj);
      }
      return finalCartObj;
    }
  }
};
